const initialState = {
  user: []
}

export default function usersReducer(state = initialState, action) {
  switch (action.type) {
    case "user":
      return {
        ...state,
		    user: action.data
      };
	  
	  case "register":
      return {
        ...state,
		    user: action.data
      };
	  
	  case "forgetpwd":
      return {
        ...state,
		    user: action.data
      };
	  
	  case "resetpwd":
      return {
        ...state,
		    user: action.data
      };
	  
	 case "changepwd":
      return {
        ...state,
		    user: action.data
      };

    default:
      return state;
  }
}